import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import HsCodesApi from '../../../../services/api/HsCodesApi';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';
import styled from 'styled-components';
import TextAreaComponent from '~/src/components/common/forms/TextInput/TextAreaComponent';
import BorderlessButton from '~/src/components/common/forms/Button/BorderlessButton';

const validationSchema = yup.object().shape({
  code: yup.string().label('Code').min(2, 'Code should be at least 2 symbols').required('Code is required'),
  nameEn: yup
    .string()
    .label('Name English')
    .min(2, 'NameEn should be at least 2 symbols')
    .required('NameEn is required'),
  nameBg: yup
    .string()
    .label('Name Bulgarian')
    .min(2, 'NameBg should be at least 2 symbols')
    .required('NameBg is required'),
});

export default function HsCodeEdit(): JSX.Element {
  const { id } = useParams();
  const [itemData, setItemData] = useState(null);
  const history = useHistory();

  const getItem = async () => {
    const res = await HsCodesApi.get(id);
    setItemData(res.data);
  };
  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    const res = await HsCodesApi.update(id, values);
    if (res.status === StatusCodes.OK) {
      history.push('/hsCodes');
    } else {
      setSubmitting(false);
    }
  };

  const onDelete = async () => {
    const res = await HsCodesApi.delete(id);
    if (res.status === StatusCodes.OK) {
      history.push('/hsCodes');
    }
  };

  useEffect(() => {
    getItem(id);
  }, []);

  return (
    <WhitePad>
      <TitleComponent
        onLeftHandler={() => {
          history.goBack();
        }}
        title="Edit HsCode"
      />
      <FormWrapper>
        {itemData !== null ? (
          <Formik
            initialValues={{
              code: itemData.code,
              nameEn: itemData.nameEn,
              nameBg: itemData.nameBg,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => saveItem(values, setSubmitting)}
          >
            {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, touched, errors }) => (
              <form onSubmit={handleSubmit} autoComplete="off">
                <FormRow>
                  <TextInputComponent
                    name="code"
                    label="Code"
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    cols={12}
                  />
                </FormRow>
                <FormRow>
                  <TextAreaComponent
                    name="nameEn"
                    label="nameEn"
                    value={values.nameEn}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    touched={touched}
                    errors={errors}
                    cols={12}
                    rows={6}
                  />
                </FormRow>
                <FormRow>
                  <TextAreaComponent
                    name="nameBg"
                    label="nameBg"
                    value={values.nameBg}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    touched={touched}
                    errors={errors}
                    cols={12}
                    rows={6}
                  />
                </FormRow>
                <FormRow>
                  <ActionWrapper>
                    <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
                    <BorderlessButton
                      marginLeft="30px"
                      variant="danger"
                      size="sm"
                      onClick={onDelete}
                      title="Delete"
                    />
                  </ActionWrapper>
                </FormRow>
              </form>
            )}
          </Formik>
        ) : null}
      </FormWrapper>
    </WhitePad>
  );
}

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
